import type { RouteObject } from 'react-router-dom';

import { RequireSection } from '@/shared/routing';

import { InventoryPage } from './ui/pages/InventoryPage';

/**
 * Inventory feature subtree, mounted under the authenticated `AppLayout` shell.
 * A single flat route — the page itself owns its tabs (Stock / Ledger / Alerts) as UI state,
 * mirroring how `catalog`'s `PricingPage` keeps its tabs in-page rather than as sub-routes.
 */
export const inventoryRoutes: RouteObject = {
  path: 'inventory',
  element: (
    <RequireSection section="inventory">
      <InventoryPage />
    </RequireSection>
  ),
};
